export default __webpack_public_path__ + "static/media/indexes.a90e41a1.png";